export default __webpack_public_path__ + "static/media/locationGeofence.71445316.png";